import axios, { type AxiosInstance } from 'axios';
import type { AuthProvider } from '../auth/authProvider';
import type { ContactRequestBody, AttachmentForm, AttachmentInput, AttachmentRequest } from './crmTypes';

export class CrmApiClient {
    // 'https://ztpywaiwec.execute-api.eu-west-1.amazonaws.com/staging'
    private constructor(private readonly axios: AxiosInstance) {}

    public static build(baseURL: string, authProvider?: AuthProvider): CrmApiClient {
        const instance = axios.create({
            baseURL: baseURL
        });
        instance.interceptors.response.use(null, error => {
            if (error.response?.status === 404) {
                error.response.data = null;
                return Promise.resolve(error.response);
            }
            return Promise.reject(error);
        });
        authProvider?.configure(instance);
        return new CrmApiClient(instance);
    }

    public async requestContact(resourceId: string, params: ContactRequestBody & { challenge: string }): Promise<{ requestId: string }> {
        const { data } = await this.axios.post(`/request/${resourceId}`, params);
        return data;
    }

    public async requestAttachment(params: AttachmentRequest): Promise<AttachmentForm> {
        const { data } = await this.axios.post("/attachment" , params);
        return data;
    }

    public async submitAttachment({ url, fields, file }: AttachmentInput): Promise<void> {
        const formData = new FormData();
        for (const [field, value] of Object.entries(fields)) {
            formData.append(field, value);
        }
        formData.append('Content-Type', file.type);
        formData.append('x-amz-meta-filename', file.name);
        formData.append('file', file);
        await this.axios.post(url, formData, {
            onUploadProgress: console.info,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }); // expected 204
    }
}